module.exports = __webpack_public_path__ + "img/logo-default.85def7b1.jpg";